import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { useTranslation } from "react-i18next";
import { NFLookupBaseDocuments } from "../../../Shared/NewForms/NFLookupBaseDocuments";
import { useFormContext } from "react-hook-form";

export const FIxedAssetsInventoriesDetailsMain = () => {
    const { t } = useTranslation();
    const { watch } = useFormContext();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("Document#")}
                        fieldName={"documentNumber"}
                        disabled
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName={"documentDate"}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupCompany
                        fieldName={"companyId"}
                        title={t("Company")}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupWarehouse
                        fieldName={"warehouseId"}
                        title={t("Warehouse")}
                        companyId={watch("companyId")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupBaseDocuments
                        fieldName={"baseDocumentAtId"}
                        title={t("BaseDocument")}
                    />
                </Col>
            </Row>
        </>
    );
};
